<template>
  <v-card>
    <v-card-title class="text-centered" v-if="user.projetSelected">
      {{ user.projetSelected.ll_programme }}
    </v-card-title>
    <v-card-text>
      <template>
        <v-data-table
          hide-default-header
          hide-default-footer
          class="elevation-0"
          :headers="headers"
          :items="user.projets"
        >
          <template v-slot:item.actions="{ item }">
            <div v-if="user.projetSelected">
              <div
                v-if="item.id_programme === user.projetSelected.id_programme"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="continuer(item)"
                      class="mx-2"
                      fab
                      dark
                      small
                      color="blue"
                    >
                      <v-icon dark>
                        mdi-motion-play-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Continuer avec ce projet</span>
                </v-tooltip>
              </div>
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="changeProjet(item)"
                      class="mx-2"
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>
                        mdi-logout
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>sortir et Changer de projet</span>
                </v-tooltip>
              </div>
            </div>
            <div v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    @click="selectProjet(item)"
                    class="mx-2"
                    fab
                    dark
                    small
                    color="green"
                  >
                    <v-icon dark>
                      mdi-play
                    </v-icon>
                  </v-btn>
                </template>
                <span>Selectionner ce projet</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
    <v-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="green" dark>mdi-format-list-checks</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Groupes :
              <span v-if="groupesDeSuperviseur.length > 0">{{
                groupesDeSuperviseur.length
              }}</span></v-list-item-title
            >
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadGroupes()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="green" dark>mdi-format-list-checks</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Membres:
              <span v-if="MembresDuSuperviseur.length > 0">{{
                MembresDuSuperviseur.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="green" dark>mdi-format-list-checks</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Ménages:
              <span v-if="MenagesDuSuperviseur.length > 0">{{
                MenagesDuSuperviseur.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadMenages()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="green" dark>mdi-format-list-checks</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Campagnes:
              <span v-if="ParcoursEffectif.length > 0">{{
                ParcoursEffectif.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadSuperviseurParcoursEffectif()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-card-actions>
      <Navigation :elements="SuperviseurNavigation" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Widget: require("@/components/Widget.vue").default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      headers: [
        {
          text: "Projet",
          align: "start",
          sortable: false,
          value: "ll_programme",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  methods: {




    ...mapActions({
      GetGroupesDeSuperviseur: "Groupes/GetGroupesDeSuperviseur",
      userLogOut: "Auth/userSignOut",
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetAllTypeDetailsEtape: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      getMyGroupes: "Mygroupes/GetAll",
      getMyHorsGroupe: "HorsGroupe/GetAll",
      GetActivites: "Activites/GetAll",

      GetFormationsDuSuperviseur:
        "FormationsDeGroupe/GetFormationsDuSuperviseur",

 
      GetMenagesDuSuperviseur: "Menages/GetMenagesDuSuperviseur",
      GetCommunesDuSuperviseurApartirDeDistricts:
        "Communes/GetCommunesDuSuperviseurApartirDeDistricts",
      GetFokontanyDuSuperviseurApartirDeDistricts:
        "Fokontany/GetFokontanyDuSuperviseurApartirDeDistricts",
      GetCampagnes: "Campagnes/GetAll",
      GetCampagneActive: "Campagnes/GetCampagneActive",


      getEtapes: "Etapes/GetAll",
      getDetailEtapes: "DetailEtapes/GetAll",
      getDistricts: "Districts/GetAll",
      GetRegions: "Regions/GetAll",
      GetProvinces: "Provinces/GetAll",
      GetThemes: "Themes/GetAll",

  
    }),
  },
  computed: {
    ...mapState({
      MenagesDuSuperviseur: (state) => state.Menages.MenagesDuSuperviseur,
      groupesDeSuperviseur: (state) => state.Groupes.groupesDeSuperviseur,
      projetSelected: (state) => state.Projets.projetSelected,
      parametres: (state) => state.Parametres.parametres,
      user: (state) => state.Auth.user,
      campagneActive: (state) => state.Campagnes.campagneActive,
      ArrayOfCampagnesActives: (state) =>
        state.Campagnes.ArrayOfCampagnesActives,
      startDate: (state) => state.Campagnes.startDate,
      endDate: (state) => state.Campagnes.endDate,
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      isAnimateur: (state) => state.Auth.isAnimateur,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      Mygroupes: (state) => state.Mygroupes.Mygroupes,
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      FormationsDeMasse: (state) => state.FormationsDeMasse.FormationsDeMasse,
      MembresDuSuperviseur: (state) => state.Membres.MembresDuSuperviseur,
      listeDistrictsDuSuperviseur: (state) =>
        state.Utils.listeDistrictsDuSuperviseur,
      formationDeMassefilterdByProject(state) {
        var listeProjets = [];
        var userProjets = state.Auth.user.projets;
        _.forEach(userProjets, function (item, index) {
          listeProjets[index] = item.id_programme;
        });

        let output = _.filter(state.FormationsDeMasse.FormationsDeMasse, (v) =>
          _.includes(listeProjets, v.programmes_id_programme)
        );

        return output;
      },
    }),
  },
};
</script>

<style scoped></style>
